<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <!-- <el-form-item label="企业id">
          <el-input
            placeholder="请输入企业id"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button size="small" type="info" v-if="supply_id > 0" @click="cancelFunc">返回上一页</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="nickname"
              label="用户昵称"
            ></el-table-column>
            <el-table-column
              prop="avatarUrl"
              label="头像"
              width="100"
            >
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.avatarUrl"
                  style="width: 40px; height: 40px; border-radius: 50%;"
                  :src="scope.row.avatarUrl"
                  fit="cover"
                ></el-image>
                <span v-else>无头像</span>
              </template>
            </el-table-column>
             <el-table-column
              prop="name"
              label="用户名"
            ></el-table-column>
              <el-table-column
              prop="phone"
              label="手机号"
            ></el-table-column>
            <!-- <el-table-column
              prop="user_id"
              label="用户ID"
              width="100"
            ></el-table-column> -->
            <el-table-column
              prop="status"
              label="状态"
              width="100"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="getStatusType(scope.row.status)"
                  size="small"
                >
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="申请时间"
              width="180"
            >
              <template slot-scope="scope">
                {{ formatTime(scope.row.create_time) }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="280">
              <template slot-scope="scope">
                <el-button
                  @click="detailClick(scope.row)"
                  type="text"
                  size="small"
                  >详情</el-button
                >
                <!-- 单独的审核按钮 -->
                <el-button
                  v-if="scope.row.status === 0"
                  @click="auditClick(scope.row)"
                  type="text"
                  size="small"
                  style="color: #409EFF;"
                  >审核</el-button
                >
                <!-- 或者保留原来的通过/拒绝按钮 -->
                <!-- <el-button
                  v-if="scope.row.status === 0"
                  @click="auditClick(scope.row, 'pass')"
                  type="text"
                  size="small"
                  style="color: #67C23A;"
                  >通过</el-button
                >
                <el-button
                  v-if="scope.row.status === 0"
                  @click="auditClick(scope.row, 'reject')"
                  type="text"
                  size="small"
                  style="color: #E6A23C;"
                  >拒绝</el-button
                > -->
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  style="color: #F56C6C;"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="成员详情"
      :visible.sync="open_detail"
      width="700px"
      :before-close="closeDetail"
    >
      <el-form ref="detailForm" :model="detailData" label-width="100px" size="small">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户昵称:">
              <span>{{ detailData.nickname || '-' }}</span>
            </el-form-item>
          </el-col>
        
        </el-row>
          <el-row>
          <el-col :span="12">
            <el-form-item label="用户名:">
              <span>{{ detailData.name || '-' }}</span>
            </el-form-item>
          </el-col>
        
        </el-row>
          <el-row>
          <el-col :span="12">
            <el-form-item label="手机号:">
              <span>{{ detailData.phone || '-' }}</span>
            </el-form-item>
          </el-col>
        
        </el-row>
          <el-row>
          <el-col :span="12">
            <el-form-item label="原因:">
              <span>{{ detailData.reason || '-' }}</span>
            </el-form-item>
          </el-col>
        
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="成员ID:">
              <span>{{ detailData.supply_member_id || '-' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态:">
              <el-tag :type="getStatusType(detailData.status)" size="small">
                {{ getStatusText(detailData.status) }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="排序:">
              <span>{{ detailData.sort || '50' }}</span>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="应用ID:">
              <span>{{ detailData.app_id || '-' }}</span>
            </el-form-item>
          </el-col> -->
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请时间:">
              <span>{{ formatTime(detailData.create_time) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="更新时间:">
              <span>{{ formatTime(detailData.update_time) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="头像:">
          <div style="margin-top: 10px;">
            <el-image
              v-if="detailData.avatarUrl"
              style="width: 80px; height: 80px; border-radius: 50%;"
              :src="detailData.avatarUrl"
              fit="cover"
            ></el-image>
            <span v-else>无头像</span>
          </div>
        </el-form-item>
        
        <!-- 可以添加更多详情信息 -->
        <!-- <el-form-item label="备注:">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="可在此添加备注信息"
            v-model="detailData.remark"
          ></el-input>
        </el-form-item> -->
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDetail">关 闭</el-button>
        <!-- <el-button type="primary" @click="saveRemark">保存备注</el-button> -->
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
      title="审核申请"
      :visible.sync="open_audit"
      width="500px"
      :before-close="closeAudit"
    >
      <div style="margin-bottom: 20px;">
        <p style="font-size: 16px; margin-bottom: 10px;">审核用户: <strong>{{ currentAuditMember.nickname }}</strong></p>
        <p style="color: #666; font-size: 14px;">用户ID: {{ currentAuditMember.user_id }}</p>
      </div>
      
      <el-form :model="auditForm" label-width="80px">
        <el-form-item label="审核结果:">
          <el-radio-group v-model="auditForm.result">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="reject">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <!-- <el-form-item label="拒绝原因:" v-if="auditForm.result === 'reject'">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入拒绝原因（可选）"
            v-model="auditForm.reason"
          ></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="审核备注:" v-if="auditForm.result === 'pass'">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="可添加通过备注（可选）"
            v-model="auditForm.remark"
          ></el-input>
        </el-form-item> -->
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAudit">取 消</el-button>
        <el-button 
          :type="auditForm.result === 'pass' ? 'primary' : 'warning'" 
          @click="confirmAudit"
          :disabled="!auditForm.result"
        >
          {{ auditForm.result === 'pass' ? '通过申请' : '拒绝申请' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SupplyApi from "@/api/supply.js";

export default {
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_detail: false,
      open_audit: false,
      supply_id: 0,
      role: "",
      
      /*详情数据*/
      detailData: {},
      
      /*审核相关*/
      currentAuditMember: {},
      auditForm: {
        result: '', // 'pass' or 'reject'
        reason: '',
        remark: ''
      }
    };
  },
  created() {
    this.supply_id = this.$route.query.supply_id;
    this.role = this.$route.query.role;
    this.formInline.search = this.$route.query.supply_id;
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
   
    getData() {
      this.curPage = 1;
      this.getTableList();
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {
        page: self.curPage,
        list_rows: self.pageSize,
        supply_id: self.formInline.search || self.supply_id
      };

      self.loading = true;
      SupplyApi.memberList(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code === 1) {
            self.tableData = data.data;
            self.totalDataNumber = data.data.length;
          } else {
            self.$message.error(data.msg || '获取数据失败');
          }
        })
        .catch(error => {
          self.loading = false;
          self.$message.error('请求失败');
          console.error(error);
        });
    },

    /*成员详情*/
    detailClick(row) {
      this.detailData = { ...row };
      this.open_detail = true;
    },

    /*关闭详情*/
    closeDetail() {
      this.open_detail = false;
      this.detailData = {};
    },

    /*保存备注*/
    saveRemark() {
      // 调用API保存备注信息
      SupplyApi.updateMemberRemark({
        supply_member_id: this.detailData.supply_member_id,
        remark: this.detailData.remark
      }, true).then(data => {
        if (data.code === 1) {
          this.$message.success('备注保存成功');
          this.closeDetail();
          this.getTableList();
        } else {
          this.$message.error(data.msg || '保存失败');
        }
      }).catch(error => {
        this.$message.error('保存失败');
      });
    },

    /*审核操作*/
    auditClick(row) {
      this.currentAuditMember = { ...row };
      // 重置表单
      this.auditForm = {
        result: '',
        reason: '',
        remark: ''
      };
      this.open_audit = true;
    },

    /*关闭审核弹窗*/
    closeAudit() {
      this.open_audit = false;
      this.currentAuditMember = {};
      this.auditForm = {
        result: '',
        reason: '',
        remark: ''
      };
    },

    /*确认审核*/
    confirmAudit() {
      let self = this;
      const params = {
        supply_member_id: this.currentAuditMember.supply_member_id,
        status: this.auditForm.result === 'pass' ? 1 : 2 // 1:通过, 2:拒绝
      };


      SupplyApi.auditMember(params, true)
        .then(data => {
          if (data.code === 1) {
            self.$message.success(`已${this.auditForm.result === 'pass' ? '通过' : '拒绝'}该申请`);
            self.closeAudit();
            self.getTableList();
          } else {
            self.$message.error(data.msg || '操作失败');
          }
        })
        .catch(error => {
          self.$message.error('操作失败');
        });
    },

    /*删除成员*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm(`确定要删除成员 "${row.nickname}" 吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          SupplyApi.delMember(
            {
              supply_member_id: row.supply_member_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error(data.msg || "删除失败");
              }
            })
            .catch(error => {
              self.$message.error("删除失败");
            });
        })
        .catch(() => {
          self.$message.info("已取消删除");
        });
    },

    /*状态文本转换*/
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝'
      };
      return statusMap[status] || '未知';
    },

    /*状态标签类型*/
    getStatusType(status) {
      const typeMap = {
        0: 'warning', // 待审核
        1: 'success', // 已通过
        2: 'danger'   // 已拒绝
      };
      return typeMap[status] || 'info';
    },

    /*时间格式化*/
    formatTime(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }
  }
};
</script>

<style scoped>
.table-wrap {
  margin-bottom: 20px;
}

.pagination {
  text-align: right;
  margin-top: 20px;
}

.common-level-rail {
  margin-bottom: 20px;
}

.common-seach-wrap {
  margin-bottom: 20px;
}

/* 详情弹窗样式 */
.detail-form .el-form-item {
  margin-bottom: 15px;
}

.detail-form .el-form-item__label {
  font-weight: bold;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/member/index.vue